import { HubConnectionManager } from '@ygtechnologies/bygr-frontend-chat';
import { getApiUrl } from '@/utils/ajax';

let chatConnectionManagerInstance: HubConnectionManager;
let cmConnectionManagerInstance: HubConnectionManager;
createConnections();

function cleanConnections() {
    if (cmConnectionManagerInstance) {
        cmConnectionManagerInstance.dispose();
    }

    if (chatConnectionManagerInstance) {
        chatConnectionManagerInstance.dispose();
    }
}

function createConnections() {
    chatConnectionManagerInstance = new HubConnectionManager(window.APP_CONFIG.API_CHAT_URL + '/hub');
    cmConnectionManagerInstance = new HubConnectionManager(getApiUrl() + '/hub');
}

export function resetConnections() {
    cleanConnections();
    createConnections();
}

export function getCMConnectionManager() {
    return cmConnectionManagerInstance;
}

export function getChatConnectionManager() {
    return chatConnectionManagerInstance;
}